import { gql } from "@grandvisionhq/graphql";
import { createReturnFailuresFragment } from "../../../fragments/operations/fragments/create-return-failures.js";
import { returnFragment } from "../../../fragments/operations/fragments/return.js";
const CREATE_RETURN = gql`
  mutation CreateReturn($input: CreateReturnInput!) {
    createReturn(input: $input) {
      return {
        ...ReturnFragment
      }
      failures {
        ...CreateReturnFailuresFragment
      }
    }
  }
  ${returnFragment}
  ${createReturnFailuresFragment}
`;
export {
  CREATE_RETURN
};
//# sourceMappingURL=create-return.js.map
